import { LGBT_KEYWORDS } from "../../global-components/src/utils/text";
import { registerTheme, ThemeEffect } from "../../hooks/useThemeEffects";

const HIGHLIGHT_CSS = `
  .lgbt-highlight {
    background: linear-gradient(
      90deg,
      #e40303 0%,
      #ff8c00 16.66%,
      #ffed00 33.33%,
      #008026 50%,
      #004dff 66.66%,
      #750787 83.33%,
      #e40303 100%
    );
    background-size: 100% 100%;
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
    background-clip: text;
    font-weight: 1000;
  }
`;


export const lgbtTheme: ThemeEffect = {
  id: "lgbt",
  keywords: LGBT_KEYWORDS,
  highlightStyle: HIGHLIGHT_CSS,
  highlightClass: "lgbt-highlight",
  trigger: () => {}
};

registerTheme(lgbtTheme);